import { render, staticRenderFns } from "./AddJob.vue?vue&type=template&id=be1b0d50&"
import script from "./AddJob.vue?vue&type=script&lang=js&"
export * from "./AddJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports